import { HttpClient } from '@angular/common/http';
import { transform } from 'ol/proj';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AddressService = /** @class */ (function () {
    function AddressService(http) {
        this.http = http;
    }
    // Check if address string is latlong decimal format
    AddressService.prototype.isLatLongDecimal = function (addressString) {
        var separators = [' ', ','];
        for (var i = 0; i < separators.length; i++) {
            var parts = addressString.split(separators[i]);
            if (parts.length === 2) {
                parts[0] = parts[0].replace(/^[,\s]+|[,\s]+$/g, '');
                parts[1] = parts[1].replace(/^[,\s]+|[,\s]+$/g, '');
                //if the two numbers are between normal range of lat and long
                if ((Number(parts[0]) >= -90 && Number(parts[0]) <= 90) &&
                    (Number(parts[1]) >= -180 && Number(parts[1]) <= 180)) {
                    return [Number(parts[1]), Number(parts[0])];
                }
            }
        }
    };
    ;
    // !!!!!!!!!!! TODO: THIS FUNCTION NEED TO BE REWRITTEN !!!!!!
    // Check if address string is latlong degree by checking degree(°) symbol ??
    // Convert it to decimal format
    AddressService.prototype.isLatLongDMS = function (addrStr) {
        // https://stackoverflow.com/questions/1140189/converting-latitude-and-longitude-to-decimal-values
        var convertDMSToDD = function (str, direction) {
            if (!str) {
                return;
            }
            var degrees = 0;
            var minutes = 0;
            var seconds = 0;
            var msPart;
            // Separate degree
            degrees = str.split('\xB0')[0];
            msPart = str.split('\xB0')[1];
            var secSeparators = ['\'\'', '\"'];
            var hasSecSeparator = false;
            for (var i = 0; i <= secSeparators.length; i++) {
                if (msPart.indexOf(secSeparators[i]) !== -1) {
                    msPart = msPart.split(secSeparators[i])[0];
                    if (msPart.indexOf('\'') !== -1) {
                        minutes = msPart.split('\'')[0];
                        seconds = msPart.split('\'')[1];
                    }
                    else {
                        seconds = msPart;
                    }
                    // Remove secondSeparator from seconds
                    seconds = seconds.split(secSeparators[i])[0];
                    hasSecSeparator = true;
                    break;
                }
            }
            if (!hasSecSeparator) {
                if (msPart.indexOf('\'') !== -1) {
                    minutes = msPart.split('\'')[0];
                }
            }
            // if (msPart.indexOf('\'\'') !== -1) {
            // 	msPart = msPart.split('\'\'')[0];
            // 	if (msPart.indexOf('\'') !== -1) {
            // 		minutes = msPart.split('\'')[0];
            // 		seconds = msPart.split('\'')[1];
            // 	} else {
            // 		seconds = msPart;
            // 	}
            // } else {
            // 	if (msPart.indexOf('\'') !== -1) {
            // 		minutes = msPart.split('\'')[0];
            // 	}
            // }
            var dd = Number(degrees) + Number(minutes) / 60 + Number(seconds) / (60 * 60);
            if (direction && (direction.toUpperCase() == 'S' || direction.toUpperCase() == 'W')) {
                dd = dd * -1;
            } // Don't do anything for N or E
            return dd;
        };
        // Has degree symbol (°) or not
        if (addrStr.indexOf('\xB0') === -1) {
            return;
        }
        // Remove all the white space / comma at beginning and end
        addrStr = addrStr.replace(/^[,\s]+|[,\s]+$/g, '').replace(/,/g, '');
        // Split by letters (should be 'N' / 'S' / 'E' / 'W')
        // addrStr = addrStr.replace(/([A-Za-z])/g, function(x){return x + ','});
        // const latParts = addrStr.split(',')[0];
        // const longParts = addrStr.split(',')[1];
        var parts = addrStr.split(/([A-Za-z])/g); // eg. ["33° 15' ", "N", " 114° 0' 36'' ", "W", ""]
        var lat, lng;
        if (parts.length <= 2) {
            // lat = convertDMSToDD(parts[0]);
            // lng = convertDMSToDD(parts[1]);
        }
        else {
            lat = convertDMSToDD(parts[0], parts[1]);
            lng = convertDMSToDD(parts[2], parts[3]);
        }
        return [lng, lat];
        // const latParts = latRaw.split(/[^\d\w]+/);
        // const longParts = longRaw.split(/[^\d\w]+/);
    };
    // Convert latlong from number to degree format, ie. aa.bbbb -> xx°yy'zz" E
    AddressService.prototype.latlongDecimalToDMS = function (longNum, latNum) {
        var toDMS = function (n) {
            var absolute = Math.abs(n);
            var degrees = Math.floor(absolute);
            var minutes = Math.floor((absolute - degrees) * 60);
            var seconds = Math.floor(((absolute - degrees) * 60 - minutes) * 60);
            return degrees + '°' + minutes + '\'' + seconds + '\"';
        };
        var longDMS, latDMS;
        var longDirection = 'E';
        var latDirection = 'N';
        if (longNum < 0) {
            longDirection = 'W';
        }
        if (latNum < 0) {
            latDirection = 'S';
        }
        longDMS = toDMS(longNum) + longDirection;
        latDMS = toDMS(latNum) + latDirection;
        return [longDMS, latDMS];
    };
    AddressService.prototype.searchAddressByGoogle = function (addressStr) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressStr + '&key=AIzaSyDb8xKLVxkLQV64Zqu3SFBF_6g9cZAp-0M';
            _this.http.get(url)
                .subscribe(function (rsp) {
                if (rsp.status === 'OK') {
                    var addresses_1 = [];
                    rsp.results.forEach(function (r) {
                        var address = {
                            addr: r.formatted_address,
                            locationType: r.geometry.location_type
                        };
                        var location = r.geometry.location;
                        var srcProject = 'EPSG:4326';
                        var targetProject = 'EPSG:3857';
                        var coord = transform([location.lng, location.lat], srcProject, targetProject);
                        address.coord = coord;
                        var bounds = r.geometry.bounds;
                        if (r.geometry.location_type !== 'ROOFTOP' && bounds) {
                            var min = transform([bounds.southwest.lng, bounds.southwest.lat], srcProject, targetProject);
                            var max = transform([bounds.northeast.lng, bounds.northeast.lat], srcProject, targetProject);
                            var boundsExtent = [min[0], min[1], max[0], max[1]];
                            address.boundsExtent = boundsExtent;
                        }
                        addresses_1.push(address);
                    });
                    resolve(addresses_1);
                }
                resolve([]);
                // $('.matchloc-popup').css('display','block');
                // $scope.matchLocation = results[0];
                // if (results.length<6) {
                // 	$scope.matchLocsListSize = results.length +1;
                // } else {
                // 	$scope.matchLocsListSize = 7;
                // };
            }, function (err) {
                resolve([]);
                console.log(err);
            });
        });
    };
    AddressService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AddressService_Factory() { return new AddressService(i0.ɵɵinject(i1.HttpClient)); }, token: AddressService, providedIn: "root" });
    return AddressService;
}());
export { AddressService };
